import React, {useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Gallery.css'; // We'll create this next
import img1 from '../Components/Images/inst11.png'
import img4 from '../Components/Images/inst12.jpg'
import img5 from '../Components/Images/inst14.jpg'
import img6 from '../Components/Images/inst15.avif'
import img7 from '../Components/Images/inst15.jpeg'
import img8 from '../Components/Images/inst9.jpg'
import img9 from '../Components/Images/inst10.jpg'
import img10 from '../Components/Images/banner/inst1.jpeg'


const Gallery = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    // const [showModal, setShowModal] = useState(false);
  // Sample gallery data (replace with your actual images)
  const galleryItems = [
    {
      id: 1,
      imageUrl: img9,
      title: 'Coding Printer',
      description: 'Thermal Inkjet Printers'
    },
    {
      id: 2,
      imageUrl: img10,
      title: 'EAS Systems',
      description: 'Security Solutions'
    },
    {
      id: 3,
      imageUrl: img1,
      title: 'Retail Weighing Scales',
      description: ''
    },
    {
      id: 4,
      imageUrl: img4,
      title: 'Portable POS',
      description: 'with receipt and scanner'
    },
    {
      id: 5,
      imageUrl: img5,
      title: 'Industrial Weighing Scales',
      description: 'Water proof scale'
    },
    {
      id: 6,
      imageUrl: img6,
      title: 'Barcode scanners',
      description: 'Handheld barcode scanner'
    },
    {
      id: 7,
      imageUrl: img7,
      title: 'Production expiry printer',
      description: 'Date coding printer'
    },
    {
      id: 8,
      imageUrl: img8,
      title: 'Packaging Machine',
      description: 'Packing machine for industry'
    }
  ];
  const openModal = (item) => {
    setSelectedImage(item);
    document.body.classList.add('modal-open');
  };

  const closeModal = () => {
    setSelectedImage(null);
    document.body.classList.remove('modal-open');
  };

  return (
    <section className="gallery-section py-5" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="container">
        <div className="section-title text-center mb-5">
          <h3 className="display-5 fw-bold" style={{fontFamily:"Poppins"}}>Our Gallery</h3>
          <p className="lead text-muted">Explore our collection of beautiful moments</p>
        </div>
        
        <div className="row g-4">
          {galleryItems.map((item) => (
            <div key={item.id} className="col-md-6 col-lg-4 col-xl-3">
              <div className="gallery-item" onClick={() => openModal(item)}>
                <img 
                  src={item.imageUrl} 
                  alt={item.title} 
                  className="img-fluid rounded"
                />
                <div className="gallery-overlay">
                  <div className="overlay-content">
                    <h5 className="text-white">{item.title}</h5>
                    <p className="text-white">{item.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal for expanded view */}
        {selectedImage && (
        <div className="image-modal">
          <div className="modal-backdrop" onClick={closeModal}></div>
          <div className="modal-container">
            <button className="close-button" onClick={closeModal}>
              <span>&times;</span>
            </button>
            <img 
              src={selectedImage.imageUrl} 
              alt={selectedImage.title} 
              className="enlarged-image"
            />
          </div>
        </div>
      )}
      </div>
    </section>
  );
};

export default Gallery;